'use strict'

module.exports = trimTrailingLines

// Remove final newline characters from `value`.
function trimTrailingLines(value) {
  return String(value).replace(/\n+$/, '')
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/trim-trailing-lines/index.js
// module id = 180
// module chunks = 0 1 9 10